import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { RequestStatus } from './types';

/**
 * The one place a request's state is turned into a label and a colour, so the
 * table, the cards and the drawer cannot disagree about what a request is.
 */
const TONE: Record<
  RequestStatus,
  'secondary' | 'success' | 'destructive' | 'default'
> = {
  pending: 'secondary',
  approved: 'success',
  rejected: 'destructive',
  registered: 'default',
};

export function StatusBadge({ status }: { status: RequestStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={TONE[status]}>{t(`accountRequests.status.${status}`)}</Badge>
  );
}
